<div class="flex flex-col justify-center items-center space-y-20 mt-20">
  <img class="w-[200px]" [src]="this.resource.header.logo" alt="Logo" />
  <div class="space-y-7">
    <p class="titleError text-center text-2xl">{{ this.resource.maintenance.title }}</p>
    <p class="text-center">{{ this.resource.maintenance.text }}</p>
    @if (message) {
      <p class="text-center">{{ message }}</p>
    }
  </div>
</div>
